































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Button, Form, FormItem, Option, Select, Tooltip } from 'element-ui';
import { milestoneTypeOptions } from '@/constants/milestoneTypeOptions';

// MilestoneDetails
import AirTransportation from '@/components/milestone/AirTransportation.vue';
import CyCfsCut from '@/components/milestone/CyCfsCut.vue';
import Devanning from '@/components/milestone/Devanning.vue';
import EventDate from '@/components/milestone/EventDate.vue';
import EventDateLocation from '@/components/milestone/EventDateLocation.vue';
import FreeText from '@/components/milestone/FreeText.vue';
import SeaTransportation from '@/components/milestone/SeaTransportation.vue';

import { milestoneService } from '@/services/MilestoneService';

import {
  ShipmentFields,
  MilestoneFields,
  MilestoneInput,
  MilestoneTypeEnum
} from '@/types/graphql/schemaTypes';

import get from 'lodash/get';

@Component({
  components: {
    AirTransportation,
    CyCfsCut,
    Devanning,
    EventDate,
    EventDateLocation,
    FreeText,
    SeaTransportation,
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-option': Option,
    'el-select': Select,
    'el-tooltip': Tooltip
  }
})
export default class Milestone extends Vue {
  @Prop() private milestone!: MilestoneFields;
  @Prop() private shipment!: ShipmentFields;

  private loading = false;
  get milestoneTypeOptions() {
    const allOptions = milestoneTypeOptions();
    // "デバン+納品"(devanning) option removed, but the Milestone data kept if exists
    return allOptions.filter(option => option.value !== 'devanning');
  }

  private milestoneInput: MilestoneInput = {
    milestoneType: get(this.milestone, 'milestoneType', MilestoneTypeEnum.pickup)
  };

  private async deleteMilestone() {
    try {
      this.loading = true;

      const response = await milestoneService.deleteMilestone(
        get(this.milestone, 'id')
      );

      if (response) {
        this.$emit('refresh');
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.deleted'),
          time: 2000
        });
      }
    } catch (error) {
      this.alertError();
    } finally {
      this.loading = false;
    }
  }

  private async updateMilestone(milestoneInput: MilestoneInput) {
    // prevent milestone to be reset when component is destoyed
    delete milestoneInput.milestoneType;

    this.milestoneInput = {
      ...milestoneInput,
      milestoneType: this.milestoneInput.milestoneType
    };

    try {
      this.loading = true;

      const response = await milestoneService.updateMilestone(
        this.milestoneInput,
        get(this.milestone, 'id')
      );

      if (response) {
        this.$emit('refresh');
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });
      }
    } catch (error) {
      this.alertError();
    } finally {
      this.loading = false;
    }
  }

  private alertError() {
    this.$store.dispatch('Alert/addAlert', {
      type: 'error',
      message: this.$t('error.push'),
      time: 2000
    });
  }

  get milestoneDetails() {
    if (!this.milestoneInput.milestoneType) {
      return null;
    }

    switch (this.milestoneInput.milestoneType) {
      case 'packing':
      case 'vanning':
      case 'custom_clearance':
        return 'eventDate';
      case 'air_transportation':
        return 'AirTransportation';
      case 'cy_cfs_cut':
        return 'CyCfsCut';
      case 'free_text':
        return 'FreeText';
      case 'sea_transportation':
        return 'SeaTransportation';
      case 'pickup':
      case 'delivery':
        return 'EventDateLocation';
      default:
        return this.milestoneInput.milestoneType.toLowerCase();
    }
  }

  @Watch('milestoneInput.milestoneType')
  changeMilestoneType() {
    let milestoneArgs: MilestoneInput = { milestoneType: this.milestoneInput.milestoneType };

    if (this.milestoneInput.milestoneType !== this.milestone.milestoneType) {
      milestoneArgs = {
        ...milestoneArgs,
        polId: null,
        podId: null
      };
    }

    this.updateMilestone(milestoneArgs);
  }
}
